// Lx720: add an url for showing the contact form automatically
window.addEventListener('load', function() {
    if( document.URL.endsWith("#contact") ) {
        document.querySelector('.js-contact').click();
    }
});